import { FormatDate, GetCurrentDateAndTime } from "commonFunctions/commonFunctions";
import React, { useEffect, useState, useContext } from "react";
import { DocumentDetailContext } from "pages/DocumentDetail/contexts/DocumentDetailContext";
import dayjs from 'dayjs';
import * as c from "../../../../utils/constants/constants";
import CustomDatePicker from "../../../../components/CustomDatePicker/CustomDatePicker";
import { Grid } from "@mui/system";
import { EhrEncountersTable } from ".";
import api from "utils/API/api";
const Encounters = (props) => {
    const { setDocumentData, data = {}, setDataSave } = useContext(DocumentDetailContext);
    const [encounterFilters, setEncounterFilters] = useState(null);
    const [dateError, setDateError] = useState(false);
    const [pagination, setPagination] = useState({ recordsPerPage: 50, currentPage: 0, totalRecords: 0, startRecord: 0 });
    const [encounterData, setEncounterData] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [loader, setLoader] = useState(false);

    useEffect(() => {

        props.setSelectedEncApp(props.selected || null);

        if (JSON.parse(localStorage.getItem(c.ENC_DATA))) {
            let filters = JSON.parse(localStorage.getItem(c.ENC_DATA));
            setEncounterFilters(filters);
        } else {
            const defaultDates = {
                fromDate: FormatDate({ date: dayjs().subtract(1, "month"), format: "MM/DD/YYYY" }),
                toDate: FormatDate({ date: dayjs().add(1, "month"), format: "MM/DD/YYYY" })
            };
            setEncounterFilters(defaultDates);
        }
    }, []);

    useEffect(() => {
        props.setSelectedEncApp(props.selected || null);
    }, [props.selected]);

    useEffect(() => {
        setPagination(() => {
            return {
                ...pagination,
                totalRecords: encounterData?.length || 0
            }
        });

    }, [encounterData]);

    useEffect(() => {
        filterData();
    }, [pagination, encounterData]);

    useEffect(() => {
        if (encounterFilters) {
            localStorage.setItem(c.ENC_DATA, JSON.stringify(encounterFilters));
            setEncounterData(null);
            setLoader(true);
            var query = {
                doc_id: data.ID,
                do_type_filter: true,
                start_date: encounterFilters.fromDate ? FormatDate({ date: dayjs(encounterFilters.fromDate).startOf("day"), format: "MM-DD-YYYY HH:mm:ss" }) : "",
                end_date: encounterFilters.toDate ? FormatDate({ date: dayjs(encounterFilters.toDate).endOf("day"), format: "MM-DD-YYYY HH:mm:ss" }) : ""
            };
            api
                .patient_encounters(query)
                .then((response) => {
                    if (response.status === 200) {
                        let sortedData = sortByDate(response.data.data, "encounter");
                        sortedData.forEach((m, i) => {
                            m.s_no = i + 1;
                        });
                        setEncounterData(sortedData);
                        setLoader(false);
                    }
                })
                .catch((error) => {
                    setLoader(false);
                });
        }

    }, [encounterFilters]);

    const sortByDate = (data, type) => {
        var res = "";
        res = data.sort((a, b) => {
            let start = a.period["start"] && new Date(a.period["start"]), end = b.period["start"] && new Date(b.period["start"]);
            if (start < end) return 1;
            if (start > end) return -1;
            return 0;
        }
        );
        return res;
    };

    const handleDate = (date, value) => {
        if (date === "from") {
            setEncounterFilters(prevState => {
                return { ...prevState, fromDate: value }
            });
        }
        else {
            setEncounterFilters(prevState => {
                return { ...prevState, toDate: value }
            });
        }

    };
    const resetFilter = () => {
        setEncounterFilters({ fromDate: "", toDate: "" });
    };

    const handleEncounterSelection = (event, data) => {
        if (event.target.checked) {
            props.setSelectedEncApp(data.identifier)
        } else
            props.setSelectedEncApp(null);
    };

    const handleChangePage = (pageNum) => {
        setPagination(() => {
            return {
                ...pagination,
                currentPage: pageNum,
                startRecord: pageNum * pagination.recordsPerPage
            }
        });
    }

    const filterData = () => {
        let data = (encounterData || []).slice(pagination.startRecord, pagination.startRecord + pagination.recordsPerPage);
        setDisplayData(data);
        setLoader(false);
    }

    const handleSubmit = () => {
        let selected = encounterData.find(m => m.identifier == props.selected);
        let finalObj = {
            "identifier": selected.identifier,
            "period": selected.period,
            "type": selected.type,
            "value": "encounter"
        }
        let result = { ...data }
        if (!result.Entity_Details.ehrDetails) result.Entity_Details.ehrDetails = { encounter: finalObj }
        else result.Entity_Details.ehrDetails.encounter = finalObj;
        setDocumentData({ ...result });
        props.setEhrPopup(false);
        setDataSave(true);
    }

    const handleCancel = () => {
        props.setEhrPopup(false);
    }

    return <div>
        <div className={loader ? "block-area-common enc-filters" : "enc-filters"}>
            <div>Encounter Start Date: </div>
            <div className="enc-filter-fields">
                <Grid style={{ paddingRight: "10px", marginLeft: "10px" }}>
                    <CustomDatePicker
                        maxDate={GetCurrentDateAndTime("MM/DD/YYYY")}
                        onChange={val => {
                            setDateError(false);
                            handleDate("from", val)
                        }}
                        onError={error => {
                            if (error) setDateError(true);
                            else setDateError(false);
                        }}
                        label="From"
                        format={'MM/DD/YYYY'}
                        variant="standard"
                        id="fromDate"
                        type="date"
                        value={encounterFilters?.fromDate ? FormatDate({ date: encounterFilters?.fromDate, format: "MM/DD/YYYY" }) : ""}
                        name="fromDate"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid style={{ paddingRight: "10px" }}>
                    <CustomDatePicker
                        minDate={FormatDate({ date: encounterFilters?.fromDate, format: "MM/DD/YYYY" })}
                        maxDate={dayjs().add(1, "month").format("MM/DD/YYYY")}
                        onChange={val => {
                            setDateError(false);
                            handleDate('to', val);
                        }}
                        onError={error => {
                            if (error) setDateError(true);
                            else setDateError(false);
                        }}
                        disableFuture={false}
                        value={encounterFilters?.toDate ? FormatDate({ date: encounterFilters?.toDate, format: "MM/DD/YYYY" }) : ""}
                        label="To"
                        format={'MM/DD/YYYY'}
                    />
                </Grid>
            </div>
            <div className="buttons-filter">
                <button
                    className="reset-button"
                    type="submit"
                    onClick={resetFilter}
                    style={{ width: "unset" }}
                >
                    <p className="reset-button-text">Get All Encounters</p>
                </button>
            </div>
        </div>
        <br />
        <EhrEncountersTable
            loader={loader}
            documentLevel={data?.Entity_Details?.classify?.documentLevel}
            encounterData={displayData}
            pagination={pagination}
            selectedEncounter={props.selected}
            handleChangePage={handleChangePage}
            handleEncounterSelection={handleEncounterSelection}
        />
        {props.selectedTab === 1 && data?.Entity_Details?.classify?.documentLevel === "Encounter" && (
            <div className="div-center">
                <button
                    className="apply-button"
                    type="submit"
                    onClick={handleSubmit}
                >
                    <p className="apply-button-text">Done</p>
                </button>
                <button
                    className="reset-button"
                    type="submit"
                    onClick={handleCancel}
                >
                    <p className="reset-button-text">Cancel</p>
                </button>
            </div>
        )}
    </div>
}

export default Encounters;